import { useSelector } from 'react-redux';
import {
  editorLeftSidebarModel,
  LeftSidebarOptions,
} from '../../../../../features/editor-left-sidebar';
import { ElementsTab } from '../../../../../features/editor-left-sidebar/ui/components/elements';
import { SnippetSidebarSettingsTab } from './settings';
import {
  CallsTab,
  RecordsTab,
} from '../../../../../features/editor-left-sidebar/ui/components';

export const SnippetEditorLeftSidebarContent = () => {
  const selectedOption = useSelector(
    editorLeftSidebarModel.selectors.selectSidebarOption
  );

  return (
    <>
      {selectedOption === LeftSidebarOptions.ELEMENTS && <ElementsTab />}
      {selectedOption === LeftSidebarOptions.SETTINGS && (
        <SnippetSidebarSettingsTab />
      )}
      {selectedOption === LeftSidebarOptions.VIDEOS && <RecordsTab />}
      {selectedOption === LeftSidebarOptions.CALLS && <CallsTab />}
    </>
  );
};
